import { createContext, useContext, useState, useCallback } from 'react'
import { useTranslation } from '../../i18n/LanguageContext'
import './ConfirmModal.css'

const ConfirmContext = createContext(null)

export const ConfirmProvider = ({ children }) => {
  const { t } = useTranslation()
  const [state, setState] = useState({
    open: false,
    title: t('confirm.title'),
    message: '',
    resolve: null
  })

  const confirm = useCallback((message, title = t('confirm.title')) => {
    return new Promise(resolve => {
      setState({ open: true, title, message, resolve })
    })
  }, [])

  const handleConfirm = () => {
    state.resolve(true)
    setState({ open: false, title: '', message: '', resolve: null })
  }

  const handleCancel = () => {
    state.resolve(false)
    setState({ open: false, title: '', message: '', resolve: null })
  }

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      {state.open && (
        <div className="confirm-overlay" onClick={handleCancel}>
          <div className="confirm-modal" onClick={e => e.stopPropagation()}>
            <h4 className="confirm-title">{state.title}</h4>
            <p className="confirm-message">{state.message}</p>
            <div className="confirm-actions">
              <button className="confirm-btn confirm-btn--cancel" onClick={handleCancel}>
                {t('account.cancel')}
              </button>
              <button className="confirm-btn confirm-btn--confirm" onClick={handleConfirm}>
                {t('confirm.confirm')}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  )
}

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext)
  if (!ctx) throw new Error('useConfirm must be used within ConfirmProvider')
  return ctx.confirm
}
